export default __webpack_public_path__ + "static/Jigarjit-5b6a188778bf01643f20ca0fd11e4378.jpg";